import {
  editorUtils,
  FormHeader,
  FormTitle,
  getLayoutComponentLabel,
  ILayoutComponent,
  useEditorStore,
  useFlowBuilder2Context,
} from '@diana/core';
import { FormControl, MenuItem, Select } from '@mui/material';
import { FLOW_BUILDER2_PAGE_NS } from '../../i18n';
import { useTranslation } from 'react-i18next';
import { useFindActiveTask } from '../../Support/useFindActiveTask';

export interface IDefaultEditorFieldProps {
  disabled: boolean;
  components: ILayoutComponent[];
}

export const DefaultEditorField = (props: IDefaultEditorFieldProps) => {
  const { disabled, components } = props;
  const { t } = useTranslation(FLOW_BUILDER2_PAGE_NS);
  const { updateAndSaveActionSetById } = useFlowBuilder2Context();
  const findActiveTask = useFindActiveTask();

  const actionSetId = useEditorStore((s) => findActiveTask(s.flow)?.actionSetId ?? '');

  const initiatorPath = useEditorStore((s) => {
    const task = findActiveTask(s.flow);
    return task ? editorUtils.getInitiatorPathFromStepConfig(task) : '';
  });

  const defaultInitiatorPath = useEditorStore((s) => {
    const task = findActiveTask(s.flow);
    return task ? editorUtils.getDefaultInitiatorPathFromStepConfig(task) : '';
  });

  return (
    <FormControl variant="standard" sx={{ mt: 1 }} fullWidth>
      <FormHeader>
        <FormTitle title={t('descriptions.linkPeopleSearchField')} required />
      </FormHeader>
      <Select
        placeholder={t('prompts.linkPeopleSearchField')}
        disabled={disabled}
        required
        onChange={(e) => {
          updateAndSaveActionSetById(actionSetId, (draft) => {
            editorUtils.applyInitiatorPathToStepConfig(draft, e.target.value);
            return draft;
          });
        }}
        value={initiatorPath === defaultInitiatorPath ? '' : initiatorPath}
      >
        {components.map((component) => (
          <MenuItem value={component.dataPath}>{getLayoutComponentLabel(component)}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
